export default __webpack_public_path__ + "static/media/Icons_4.222576f2.svg";